<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewbox="0 0 24 24"
    :class="`animate-spin ${customStyle}`"
  >
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <path
      class="fill-current"
      d="M18.364 5.636L16.95 7.05A7 7 0 1019 12h2a9 9 0 11-2.636-6.364z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SpinnerLarge',
  props: {
    customStyle: {
      type: String,
      default: 'h-6 w-6',
    },
  },
}
</script>
